<template>
  <span>
    <div class="ui right floated small teal basic button" @click="showModal">
      <i class="add icon"></i>
      <span>Add Actions</span>
    </div>
    <div class="ui basic modal" :id="modalId">
      <div class="header">Add New Action(s) for Patient ID: {{ medgateId }}
      </div>
      <div class="content">
        <p><b>Patient Objective(s)</b>: {{ formattedPatientObjective }}</p>
        <p><b>Notes</b>: <span v-if="patientNotes===null || patientNotes ===''">Not filled.</span><span v-else v-html="patientNotes"></span></p>
        <div class="ui form">
          <div class="field">
            <label style="color: white">New Action(s) (Short Name)</label>
            <select multiple
                    class="ui fluid search dropdown"
                    :id="patientActionPlanDropdown"
                    v-model="currentSelectedIdList">
              <option disabled value="">Not assigned</option>
              <option v-for="action in coachingActionsAll"
                      v-if="action.data.deletedStatus === false && selectedIdList.indexOf(action.id) === -1"
                      :value="action.id">{{ action.data.shortName }}
              </option>
            </select>
          </div>
        </div>
        <br>
       </div>
      <div class="actions">
        <div class="ui left floated cancel button" @click="resetSelection">Cancel</div>
        <div class="ui approve button" @click="addToPatient">Add</div>
      </div>
    </div>
  </span>
</template>

<script>
  import { mapState } from 'vuex'
	export default {
    props: {
      medgateId: {
        required: true
      },
      selectedIdList: {
        type: Array,
        required: true,
        default: function(){
          return []
        }
      },
      patientObjective: {
        type: Array
      },
      patientNotes: {
        type: String
      }
    },
		data() {
			return {
			  modalId: 'add-one-action-plan'+ this._uid,
        currentSelectedIdList: [],
        patientActionPlanDropdown: 'patient-action-plan-dropdown'+ this._uid,
      }
		},
		computed: {
      ...mapState(['coachingActionsAll']),

      formattedPatientObjective(){
        if (this.patientObjective.length === 0) {
          return 'Not selected'
        }
        else {
          return this.patientObjective.join(', ');
        }
      },
    },
		methods: {
      resetSelection(){
        this.currentSelectedIdList = [];
        $('#' + this.patientActionPlanDropdown).dropdown('clear');
        $('#' + this.modalId).modal('hide');
      },
      addToPatient(){
        let payload = this.selectedIdList.concat(this.currentSelectedIdList);
        this.$emit('updateActions', payload);
        this.resetSelection();
      },
		  showModal(){
        this.currentSelectedIdList = [];
        $('#' + this.modalId).modal({ closable: false, autofocus: false }).modal('show');
        $('#' + this.patientActionPlanDropdown).dropdown();
      }
    },
    beforeDestroy() {
      let modal = document.querySelector('#' + this.modalId);
      if (modal !== null) {
        modal.remove();
      }
    }
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/patients/PatientActionItemButtonDropdown.vue